// Anonymes Usage-Event-Tracking via Rybbit.
// Fail-safe: kein Throw wenn window oder window.rybbit nicht verfügbar.
const TOOL = "regalabstand";

export function track(name, props = {}) {
  try {
    if (typeof window !== "undefined" && window.rybbit && typeof window.rybbit.event === "function") {
      window.rybbit.event(name, { tool: TOOL, ...props });
    }
  } catch {
    /* Analytics darf den Rechner nie crashen lassen */
  }
}

const _settleTimers = {};
export function trackSettled(name, props = {}, delay = 800) {
  const key = name + ":" + (props.calculator || "");
  clearTimeout(_settleTimers[key]);
  _settleTimers[key] = setTimeout(() => track(name, props), delay);
}
